import React from 'react';

import { Space } from 'antd-v5';
import { FormattedMessage } from 'react-intl';
import { Text } from 'scouting-ui/lib';

import type { MBCRecord } from '@appTypes/esb';
import { getPreferredLastName } from '@shared/utils/preferredLastName';

import styles from './PersonNameWithContact.module.scss';

const removePrefix = (phoneNumber: string): string => {
  if (phoneNumber.startsWith('+')) {
    return phoneNumber.replace(/^\+\S*\s/, '');
  }

  return phoneNumber;
};

const PersonNameWithContact = ({ record }: { record: MBCRecord }) => {
  const email = record?.primaryContactInfo?.email;
  const fullPhoneNumber = removePrefix(
    record?.primaryContactInfo?.phoneNumber || '',
  );

  const contentDetails = (
    <Space direction="horizontal" size={4}>
      <Space direction="vertical" size={4}>
        <Text className={styles.wrapNoBreak}>
          {getPreferredLastName(record)}
        </Text>
        {email && (
          <Text style={{ whiteSpace: 'nowrap' }}>
            <FormattedMessage id="page.mbcSearch.table.popover.label.email" />
            {email}
          </Text>
        )}
        {fullPhoneNumber && (
          <Text style={{ whiteSpace: 'nowrap' }}>
            <FormattedMessage id="page.mbcSearch.table.popover.label.phone" />
            {fullPhoneNumber}
          </Text>
        )}
      </Space>
    </Space>
  );

  return contentDetails;
};

export default PersonNameWithContact;
